<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="fmt03">
<hr class="hr1"/>
<p class="epigraph4">It is therefore to this question of labor that all other things are linked.</p>
<p class="epigraph4">—Chef du district de Mananara, 1911</p>
</a></div><a id="fmt03">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?1f943ff9